gsap.registerPlugin(ScrollTrigger);



/* ══ HERO ENTRANCE ════════════════════════════ */
startHeroEntrance();
function startHeroEntrance(){
  gsap.utils.toArray('.hero .rw').forEach((w,i)=>{
    gsap.to(w,{y:0,duration:1,ease:'power3.out',delay:i*.08});
  });
  gsap.fromTo('.hero-line',{scaleX:0},{scaleX:1,duration:1.2,ease:'power2.inOut',delay:.3,transformOrigin:'left'});
  gsap.to(['.hero-meta-row','.hero-sub','.hero-form'],{opacity:1,y:0,duration:.9,ease:'power3.out',stagger:.12,delay:.4});
}

gsap.set(['.hero-meta-row','.hero-sub','.hero-form'],{opacity:0,y:16});

/* ══ NAV ══════════════════════════════════════ */
const nav=document.getElementById('nav');
window.addEventListener('scroll',()=>nav.classList.toggle('up',scrollY>80),{passive:true});





/* ══ QUOTE TEXT REVEAL ══════════════════════ */
ScrollTrigger.create({
  trigger:'.quote-elements-sec',
  start:'top 70%',
  onEnter:()=>{
    gsap.to('.quote-elements-sec .rw',{y:0,duration:1.1,ease:'power3.out',stagger:.1});
    gsap.from('.qe-text-item',{opacity:0,y:24,duration:1.1,ease:'power3.out',stagger:.15,delay:.4});
  }
});

/* ══ STATS ══════════════════════════════════ */
ScrollTrigger.create({
  trigger:'.stats-sec',
  start:'top 75%',
  onEnter:()=>{
    gsap.from('.sg-item',{opacity:0,y:24,duration:.9,ease:'power3.out',stagger:.12});
  }
});

/* ══ WAITLIST TEXT REVEAL ═══════════════════ */
ScrollTrigger.create({
  trigger:'.waitlist-sec',
  start:'top 70%',
  onEnter:()=>{
    gsap.to('.waitlist-sec .rw',{y:0,duration:1.1,ease:'power3.out',stagger:.1});
    gsap.from(['.wl-sub','.wl-form','.wl-promise'],{opacity:0,y:20,duration:.9,ease:'power3.out',stagger:.12,delay:.3});
  }
});

/* ══ FOOTER LOGO REVEAL ═════════════════════ */
ScrollTrigger.create({
  trigger:'.footer',
  start:'top 80%',
  onEnter:()=>{
    gsap.from('.ft-logo-xl',{opacity:0,y:30,duration:1,ease:'power3.out'});
    gsap.from(['.ft-col','.ft-col-form'],{opacity:0,y:20,duration:.8,ease:'power3.out',stagger:.1,delay:.2});
  }
});

/* ══ MODAL ════════════════════════════════════ */
window.openModal = function() {
  document.getElementById('rhModal').classList.add('active');
}
window.closeModal = function() {
  document.getElementById('rhModal').classList.remove('active');
}
